export const UNIVERSAL_STUDIO_SLUG = 'universal-pictures';
export const FOCUS_STUDIO_SLUG = 'focus-features';

export const BASE_REGION_CODE = 'base';

export const MOVIE_PLATFORM_TYPE = 'movie_platform';
export const LOCAL_MOVIE_TYPE = 'local_movie_page';
export const LINK_OUT_TYPE = 'link_out';
export const PLACEHOLDER_TYPE = 'placeholder';

export const MOVIE_TYPE_LABEL_DICTIONARY = {
	[MOVIE_PLATFORM_TYPE]: 'Movie Platform',
	[LOCAL_MOVIE_TYPE]: 'Local Movie Page',
	[LINK_OUT_TYPE]: 'Link Out',
	[PLACEHOLDER_TYPE]: 'Holding Page',
};